import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const Field = ({ label, required, error, htmlFor, children }) => (
  <div className="flex flex-col">
    <label htmlFor={htmlFor} className="mb-2 text-xs font-semibold uppercase tracking-[0.14em] text-ns-ink">
      {label} {required ? <span className="text-ns-bronze">*</span> : <span className="font-normal normal-case tracking-normal text-ns-muted">(optional)</span>}
    </label>
    {children}
    {error && <p data-testid={`error-${htmlFor}`} className="mt-1.5 text-xs font-medium text-red-700">{error}</p>}
  </div>
);

export const inputCls = (err) =>
  `h-12 w-full rounded-xl border bg-ns-ivory/60 px-4 text-[15px] text-ns-ink placeholder:text-ns-muted/70 outline-none transition-[border-color,box-shadow,background-color] duration-300 focus:bg-white focus:border-ns-emerald focus:shadow-[0_0_0_4px_rgba(11,60,42,0.08)] ${
    err ? "border-red-400" : "border-ns-emerald/15"
  }`;

export const SelectField = ({ id, value, onChange, options, placeholder, error, testId }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger id={id} data-testid={testId} className={`${inputCls(error)} [&>span]:text-left`}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent data-lenis-prevent className="z-[70] border-ns-emerald/15 bg-white">
      {options.map((o) => (
        <SelectItem key={o} value={o} data-testid={`${testId}-option-${slug(o)}`} className="cursor-pointer text-[15px] focus:bg-ns-cream">
          {o}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
